import { connect } from 'react-redux';

// selectors
import { getStep, getNumSteps, getStepTitleTextKey } from 'create/selectors';
import { isLastStep as isLastStepFunc } from 'script-flow/selectors';

// components
import ScriptFlowStepHeader from './ScriptFlowStepHeader';

export default connect(
  (state) => ({
    isLastStep: isLastStepFunc(state),
    numSteps: getNumSteps(state),
    step: getStep(state),
    stepTitleTextKey: getStepTitleTextKey(state)
  })
)(ScriptFlowStepHeader);
